import React, { useState } from "react";
import { BreadcrumbsContainer } from "./Breadcrumbs.style";
import { CommonMFE, Helpers } from "@tpd-web-common-libs/nodejs-library";
import { Providers, ReactMFE } from "@tpd-web-common-libs/nodejs-library";

type TBreadcrumbsProps = {
  breadcrumbs: Providers.TBreadcrumbs;
  className: string;
  isEditMode: boolean;
  id: string;
};

export const Breadcrumbs = (props: TBreadcrumbsProps) => {
  const { breadcrumbs, className, isEditMode, id } = props;

  const [layer] = useState(() => {
    const dataLayer = {
      page_breadcrumbs:
        (breadcrumbs || []).map((breadcrumb) => breadcrumb.title).join(" > ") ||
        "",
    };

    const analyticsService = Providers.AnalyticsService.getInstance();
    analyticsService.updateSourceDataLayer(dataLayer);

    return dataLayer;
  });

  const breadcrumbsElem = breadcrumbs.map((element, index) => {
    let elementContent = <>{element.title}</>;
    const isLastElement = index === breadcrumbs.length - 1;
    if (!isLastElement) {
      elementContent = (
        <ReactMFE.Link
          __deps__={React}
          href={element.url}
          data-disabled={isEditMode}
        >
          {elementContent}
        </ReactMFE.Link>
      );
    }
    return (
      <li
        key={CommonMFE.generateID(id, `breadcrumbs-item`, index)}
        className={"breadcrumb-item" + (isLastElement ? " current" : "")}
      >
        {elementContent}
      </li>
    );
  });

  return (
    <>
      <BreadcrumbsContainer
        className="breadcrumbs"
        style={{ marginLeft: "-4px" }}
      >
        <ol className={className}>{breadcrumbsElem}</ol>
      </BreadcrumbsContainer>
      <div
        className={Helpers.AnalyticsHelper.SOURCE_DATA_LAYER_CLASS}
        data-datalayer={Helpers.AnalyticsHelper.stringifyDataLayer(layer)}
      />
    </>
  );
};
